/** Alta manual de jugador (pedido Eduardo 2026-07-28): teléfono y email NO
 * son opcionales — el email es el usuario de acceso del jugador. Compartido
 * por las dos superficies de alta manual (Jugadores → Nuevo jugador y el
 * wizard de inscripción) para que NINGUNA pueda enviar `phone: null` /
 * `email: null` aunque el `required` del navegador no aplique (gate de
 * Hermes en #145: los inputs vivían en otro formulario que el submit). */
export function altaManualNuevoJugadorError(input: {
  firstName: string;
  phone: string;
  email: string;
}): string | null {
  if (!input.firstName.trim()) return "El nombre es obligatorio.";
  if (!input.phone.trim()) return "El teléfono es obligatorio.";
  if (!input.email.trim()) {
    return "El email es obligatorio: será el usuario de acceso del jugador.";
  }
  return null;
}
